import React, { useState, useEffect } from "react";
import {
  Box,
  Tab,
  Tabs,

} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import HistoryIcon from "@mui/icons-material/History";
import NewEntryTab from "./NewEntryTab";
import CompareTab from "./CompareTab";
import PharmaHistoryTab from "./PharmaHistoryTab";


// ─── Tab Panel ────────────────────────────────────────────────────────────────
function TabPanel({ children, value, index }) {
  return (
    <div hidden={value !== index}>
      {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
    </div>
  );
}




// ─── Main PharmaTracker ────────────────────────────────────────────────────────
const PharmaTracker = () => {
  const [activeTab, setActiveTab] = useState(0);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const tabConfig = [
    { label: "New Entry", icon: <AddIcon sx={{ fontSize: 17 }} />, count: null },
    { label: "History", icon: <HistoryIcon sx={{ fontSize: 17 }} />, count: 0 },
    { label: "Compare", icon: <CompareArrowsIcon sx={{ fontSize: 17 }} />, count: 0 },
    
  ];

  return (
    <div style={{ padding: "0" }}>
      <Box sx={{ marginX: "1%", marginTop: "0rem", padding: "0px" }}>
        {/* Tab Bar */}
        <Tabs
          value={activeTab}
          onChange={(_, v) => setActiveTab(v)}
          textColor="inherit"
          indicatorColor="primary"
          sx={{
            position: "sticky",
            top: "3.75rem",
            zIndex: 10,
            background: "#fff",
            marginTop: "-0.2rem",
            padding: "10px",
            borderRadius: "12px",
            "& .MuiTab-root": { color: "#000", textTransform: "none", fontSize: "14px", minHeight: 44 },
            "& .Mui-selected": { color: "#0576FC" },
            "& .MuiTabs-indicator": { backgroundColor: "#0576FC" },
          }}
        >
          {tabConfig.map((tab, i) => (
            <Tab
              key={i}
              label={
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
                  {tab.icon}
                  <span>{tab.label}</span>
                  {/* {tab.count !== null && (
                    <Box
                      sx={{
                        background: i === activeTab ? "#0576FC" : "#e0e0e0",
                        color: i === activeTab ? "#fff" : "#555",
                        borderRadius: "12px",
                        fontSize: "11px",
                        fontWeight: 700,
                        px: 0.9,
                        py: 0.1,
                        minWidth: 20,
                        textAlign: "center",
                        transition: "all 0.2s",
                      }}
                    >
                      {tab.count}
                    </Box>
                  )} */}
                </Box>
              }
            />
          ))}
        </Tabs>

        {/* Tab Content */}
        <Box sx={{ p: 0 }}>
          <TabPanel value={activeTab} index={0}>
            <NewEntryTab />
          </TabPanel>
           <TabPanel value={activeTab} index={1}>
            <PharmaHistoryTab />
          </TabPanel>
          <TabPanel value={activeTab} index={2}>
            <CompareTab />
          </TabPanel>
         
        </Box>
      </Box>
    </div>
  );
};

export default PharmaTracker;
